import Vue from 'vue'
import VueResource from 'vue-resource'
import { sync } from 'vuex-router-sync'
import * as config from './config.js'
import * as env from './env'
import router from './router'
import store from './store'
import filters from './filters'
import mixin from './mixin'
import App from './App'
import VueAnalytics from 'vue-analytics'

// Components import
import AsyncComputed from 'vue-async-computed'
import VueEsc from 'vue-esc'
import ToggleButton from 'vue-js-toggle-button'
import Snotify from 'vue-snotify/vue-snotify.min.js'
import VueScrollto from 'vue-scrollto'
import VueCookie from 'vue-cookie'
import VueApexCharts from 'vue-apexcharts'

let idGA = 'UA-135025349-2' // Gestão - PRODUÇÃO
if (process.env.NODE_ENV !== 'production') {
  idGA = 'UA-135025349-3' // Gestão - DEV
}

Vue.use(Snotify, {
  toast: {
    timeout: 5000,
    position: 'rightTop'
  }
})

Vue.use(VueAnalytics, {
  id: idGA,
  router,
  autoTracking: {
    page: true
  }
})

// Vue plugins configuration
Vue.use(VueResource)
Vue.use(AsyncComputed)
Vue.use(VueEsc)
Vue.use(ToggleButton)
Vue.use(VueScrollto)
Vue.use(VueCookie)
Vue.use(VueApexCharts)
// Vue.use(window.VueCharts)

import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadHighchartsMore from 'highcharts/highcharts-more'
import loadSolidGauge from 'highcharts/modules/solid-gauge'
loadHighchartsMore(Highcharts)
loadSolidGauge(Highcharts)
Vue.use(VueHighcharts, { Highcharts })

const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// Components
Vue.component('app', App)

import InputCep from './components/forms/inputs/InputCep'
import InputBanks from './components/forms/inputs/InputBanks'
import InputBrands from './components/forms/inputs/InputBrands'
import InputStates from './components/forms/inputs/InputStates'
import InputCities from './components/forms/inputs/InputCities'
import InputNeighborhoods from './components/forms/inputs/InputNeighborhoods'
import InputIdentifiers from './components/forms/inputs/InputIdentifiers'
import InputNumber from './components/forms/inputs/InputNumber'
import InputSelect from './components/forms/inputs/InputSelect'
import InputText from './components/forms/inputs/InputText'
import InputPhone from './components/forms/inputs/InputPhone'
import InputCreditCard from './components/forms/inputs/InputCreditCard'
import InputTextarea from './components/forms/inputs/InputTextarea'
import InputDate from './components/forms/inputs/InputDate'
import InputEmail from './components/forms/inputs/InputEmail'
import InputFile from './components/forms/inputs/InputFile'
import InputFileNotBase64 from './components/forms/inputs/InputFileNotBase64'
import PaginationBootstrap from './components/bootstrap/PaginationBootstrap'
import ModalBootstrap from './components/bootstrap/ModalBootstrap'
import { typeahead, tooltip, buttonGroup, radio, popover, tabs, tab, alert, progressbar, checkbox } from 'vue-strap'
import Loading from './components/app/Loading'
import ClientStatus from './components/app/ClientStatus'
import QuantityRents from './components/app/QuantityRents'
import ClientsPhotosMenu from './components/app/ClientsPhotosMenu'
import RentPreRegistrationsMenu from './components/app/RentPreRegistrationsMenu'
import ChatMenu from './components/app/ChatMenu'
import ChartRentsByYears from './components/app/ChartRentsByYears'
import ChartRentsStartedByType from './components/app/ChartRentsStartedByType'
import ChartRegistrationsByYears from './components/app/ChartRegistrationsByYears'
import ChartRegistrationsByStatus from './components/app/ChartRegistrationsByStatus'
import MktpRentStatus from './components/app/MktpRentStatus'

Vue.component('input-cep', InputCep)
Vue.component('input-banks', InputBanks)
Vue.component('input-brands', InputBrands)
Vue.component('input-states', InputStates)
Vue.component('input-cities', InputCities)
Vue.component('input-neighborhoods', InputNeighborhoods)
Vue.component('input-identifiers', InputIdentifiers)
Vue.component('input-number', InputNumber)
Vue.component('input-select', InputSelect)
Vue.component('input-text', InputText)
Vue.component('input-phone', InputPhone)
Vue.component('input-credit-card', InputCreditCard)
Vue.component('input-textarea', InputTextarea)
Vue.component('input-date', InputDate)
Vue.component('input-email', InputEmail)
Vue.component('input-file', InputFile)
Vue.component('input-file-not-base-64', InputFileNotBase64)
Vue.component('pagination-bootstrap', PaginationBootstrap)
Vue.component('modal-bootstrap', ModalBootstrap)
Vue.component('checkbox', checkbox)
Vue.component('popover', popover)
Vue.component('tabs', tabs)
Vue.component('tab', tab)
Vue.component('alert', alert)
Vue.component('typeahead', typeahead)
Vue.component('tooltip', tooltip)
Vue.component('radio', radio)
Vue.component('progressbar', progressbar)
Vue.component('button-group', buttonGroup)
Vue.component('loading', Loading)
Vue.component('client-status', ClientStatus)
Vue.component('quantity-rents', QuantityRents)
Vue.component('clients-photos-menu', ClientsPhotosMenu)
Vue.component('rent-pre-registrations-menu', RentPreRegistrationsMenu)
Vue.component('chat-menu', ChatMenu)
Vue.component('chart-rents-by-years', ChartRentsByYears)
Vue.component('chart-rents-started-by-type', ChartRentsStartedByType)
Vue.component('chart-registrations-by-years', ChartRegistrationsByYears)
Vue.component('chart-registrations-by-status', ChartRegistrationsByStatus)
Vue.component('mktp-rent-status', MktpRentStatus)
Vue.component('apexchart', VueApexCharts)

sync(store, router)

Vue.http.options.root = config.apiURL
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Accept', 'application/json')
  if (store.state.user.access_token) {
    request.headers.set('Authorization', 'Bearer ' + store.state.user.access_token)
    request.headers.set('ClientId', env.clientId)
  }
  next((response) => {
    // TODO: Tratar os retornos das Exceptions e emitir um alert
    if (response.status === 401) {
      store.commit('UNSET_USER')
      router.push({name: 'login'})
    }
    if (response.data.access_token) store.commit('CHANGE_USER', response.data)
  })
})

Vue.config.keyCodes = {
  'enter': [13],
  'arrow-keys': [37, 38, 39, 40],
  'arrow-vertical-keys': [38, 40],
  'arrow-horizontal-keys': [37, 39]
}

new Vue({
  router,
  store,
  filters,
  mixin
}).$mount('#app')

if (process.env.NODE_ENV !== 'development') Vue.config.devtools = false



// WEBPACK FOOTER //
// ./src/main.js